import { createContext } from "react";
import type { DeskTab } from "../lib/desk-tabs";

/**
 * Which desk view is showing, and whether the submission form is open (`APP-017`).
 *
 * Both were `DeskScreen` state until the masthead needed to reach them. `AppHeader` renders
 * outside `SessionGate` — it is on screen before anyone is signed in — so it cannot be handed
 * a callback by a screen that has not mounted. Lifting the state above both consumers is the
 * alternative to the desk registering a handler into the header through an effect, which
 * would leave one painted frame in which the masthead's action did nothing.
 *
 * Nothing about the four views changed: they are still the real addresses `useDeskTab`
 * manages, and `src/lib/desk-tabs.ts` is still the only place that says what they are.
 */
export interface DeskViewValue {
  /** The view currently showing. */
  tab: DeskTab;
  /** Move to a view, pushing its address. */
  goTo: (tab: DeskTab) => void;
  /** Whether the submission form is open on the deals view. */
  submitOpen: boolean;
  /** Open the submission form, bringing the founder to the view that holds it. */
  openSubmit: () => void;
  closeSubmit: () => void;
}

export const DeskViewContext = createContext<DeskViewValue | null>(null);
